"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindRequest = void 0;
var BindRequest = /** @class */ (function () {
    function BindRequest() {
    }
    return BindRequest;
}());
exports.BindRequest = BindRequest;
;
//# sourceMappingURL=bind.request.js.map